import { render, staticRenderFns } from "./AdminTaskWidget.vue?vue&type=template&id=0cde0813"
import script from "./AdminTaskWidget.vue?vue&type=script&lang=js"
export * from "./AdminTaskWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports